/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './batch.tpl.html';
import './batchDetail.tpl.html';

angular
  .module('mobile.admin.batch', ['ngAnimate', 'mobile.batch'])
  .controller(
    'MobileBatchCtrl',
    function (
      $scope,
      $rootScope,
      MOBILE_EVENTS,
      $filter,
      $state,
      httpBatch,
      httpQueue,
      progressFactory,
      batchUtils,
      batchesInfo,
      VIEW_STATES
    ) {
      var STATUS = batchUtils.STATUS_MOBILE,
        NOBATCH = 'NONE';
      // Check batchesInfo and redirect view to first time view if there are no batches.
      //TODO: will we need a mobile version for the start state?
      if (batchesInfo.rows.length === 0) {
        $state.go(VIEW_STATES.MOBILE_START);
      }

      $scope.batches = [];
      $scope.showBatchOne = true;
      $scope.enableBatchAnimation = false;

      /**
       * Function that will pad the loaded batches to ensure there are 12 and
       * set the current batch to that one found at index 0.
       *
       * @param {object[]} batchesInfo - The array of batches returned from the server.
       */
      function setBatches(batchesInfo) {
        // pad the array with empty objects if there are not enough batches to fill the bar.
        while (batchesInfo.rows.length < 12) {
          batchesInfo.rows.push({
            status: NOBATCH
          });
        }

        $scope.batches = batchesInfo.rows;
        if ($scope.batches.length > 0) {
          $scope.setBatch(0, false);
        }
      }

      /**
       * Utility function used to clear the selected value from all batches.
       */
      function clearSelected() {
        angular.forEach($scope.batches, function (batch) {
          batch.selected = false;
        });
      }

      /**
       * Create a class list for the passed batch based on it's properties.
       *
       * @param {Object} batch - A batch object.
       * @param {boolean} last - True if this is the last batch in the list.
       *
       * @returns {string} A space delimited string of classes that are valid for the boink.
       */
      $scope.getBoinkClass = function (batch, last) {
        batch = batch || {};
        var cls = STATUS[batch.status].boinkCls || '';

        if (batch.selected) {
          cls = cls + ' sbsf-boink-selected';
        }

        if (last) {
          cls = cls + ' sbsf-boink-last';
        }

        return cls;
      };

      /**
       * Handler for all link that direct the app to the history log.
       */
      $scope.gotoHistory = function () {
        //TODO: this will direct to the mobile log view
        $state.go(VIEW_STATES.LOG_HOME);
      };

      /**
       * Utility function for setting the current selected batch in the batches array.  Updates all
       * scope properties bound to the batch template based on the selected batch.
       *
       * @param {Number} batchIndex - The index of the batch in the batches array.
       * @param {boolean} autoJump - Whether to jump to the details view if batch is already selected.
       */
      $scope.setBatch = function (batchIndex, autoJump) {
        var batch = $scope.batches[batchIndex];

        // If current selected batch is the batch that was clicked then jump to batch
        if ($scope.currentBatch === batch && autoJump) {
          $scope.goToBatch();
          return;
        }

        // Only set the batch if the status is valid.
        if (batch.status !== NOBATCH) {
          // If the index is not 0 enable the animations
          if (batchIndex !== 0) {
            $scope.enableBatchAnimation = true;
          }

          // When the showBatchOne value is toggled it will result in the animation
          // in the UI.  To give the ui as much chance as possible to be ready for that
          // set the data bound vars first.  This is why the falsey is used here.
          if (!$scope.showBatchOne) {
            $scope.batchOne = batch;
          } else {
            $scope.batchTwo = batch;
          }
          $scope.showBatchOne = !$scope.showBatchOne;

          // clear the previously selected batch.
          clearSelected();
          batch.selected = true;

          // Set a property if this is the batch at position 0
          if (batchIndex === 0) {
            batch.first = true;
          }

          $scope.currentBatch = batch;
        }
      };

      /**
       * Redirect the view to the batch detail view.
       */
      $scope.goToBatch = function () {
        batchUtils.currentBatch = $scope.currentBatch;
        var batchDate = batchUtils.getTitleBatchDate();
        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: batchDate,
          previous: VIEW_STATES.MOBILE_HOME
        });

        $state.go(VIEW_STATES.MOBILE_BATCH_HOME);
      };

      /**
       * Return the formatted date if a date is provided, empty string
       * if none.
       * @param {string} date - The date to be formatted
       * @returns {String} - The formatted date
       */
      $scope.getFormattedDate = function (date) {
        if (date) {
          return moment(date).format('M/D');
        } else {
          //Return an empty space.
          return '&nbsp;';
        }
      };

      // load the batches from the initial resolved value.
      setBatches(batchesInfo);
    }
  )
  /**
   *  Controller for a batch detail view directive.
   */
  .controller('MobileBatchDetailCtrl', function ($scope, $filter, batchUtils) {
    var STATUS = batchUtils.STATUS,
      batchDate,
      errorText,
      warningText;

    /**
     * Returns the comma separated value for the number
     * @param {number} num - The number to apply the filter to.
     * @return {string} The number with commas applied.
     */
    $scope.getNum = function (num) {
      return $filter('number')(num);
    };

    if ($scope.batch) {
      batchDate = moment($scope.batch.date);
      $scope.batch.selected = true;
      errorText = $filter('pluralize')($scope.batch.errors, 'SINGLE_ERROR', 'NUM_ERRORS');
      warningText = $filter('pluralize')($scope.batch.warnings, 'SINGLE_WARNING', 'NUM_WARNINGS');

      $scope.batchDate = $filter('i18n')('BATCH_DATE', [
        batchDate.format('ddd,  MMM D[,] YYYY'),
        batchDate.format('h:mm a')
      ]);
      $scope.bigBoinkCls = STATUS[$scope.batch.status] ? STATUS[$scope.batch.status].bigBoinkCls : '';
      $scope.protectedPctCls = STATUS[$scope.batch.status].textCls;
      $scope.batchMsg =
        ($scope.batch.first ? $filter('i18n')('BATCH_LATEST_PREFIX') : $filter('i18n')('BATCH_OTHER_PREFIX')) +
        $filter('i18n')(STATUS[$scope.batch.status].batchMsgKey);
      $scope.protectedPct = $filter('i18n')('PERCENT_PROTECTED', batchUtils.getBatchPercent($scope.batch));
      $scope.batchWarn = $filter('i18n')('BATCH_MSG_TEMPLATE_SHORT', [errorText, warningText]);
    }
  })
  /**
   * The directive for the batch detail view.
   */
  .directive('mobileBatchDetail', function () {
    return {
      templateUrl: 'mobile/admin/batch/batchDetail.tpl.html',
      scope: {
        batch: '=batch'
      },
      controller: 'MobileBatchDetailCtrl'
    };
  });
